import { render, staticRenderFns } from "./LanguageSelectBox.vue?vue&type=template&id=5c2a4956&scoped=true"
import script from "./LanguageSelectBox.vue?vue&type=script&lang=js"
export * from "./LanguageSelectBox.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectBox.vue?vue&type=style&index=0&id=5c2a4956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a4956",
  null
  
)

export default component.exports